export default __webpack_public_path__ + "static/media/doc3.8423b656.svg";